export const ICONS = {
  ACCOUNT_CIRCLE_OUTLINE: 'account-circle-outline',
  ACCOUNT_DETAILS_OUTLINE: 'account-details-outline',
  ACCOUNT_OUTLINE: 'account-outline',
  ALERT_CIRCLE_OUTLINE: 'alert-circle-outline',
  ALERT_OCTAGRAM_OUTLINE: 'alert-octagram-outline',
  ALERT_OUTLINE: 'alert-outline',
  APARTMENT: 'apartment',
  APPS: 'apps',
  ARROW_COLLAPSE_LEFT: 'arrow-collapse-left',
  ARROW_COLLAPSE_RIGHT: 'arrow-collapse-right',
  ARROW_DOWN: 'arrow-down',
  ARROW_LEFT: 'arrow-left',
  ARROW_RIGHT: 'arrow-right',
  ARROW_UP: 'arrow-up',
  AUTO_MODE: 'auto-mode',
  AUTO_MODE_VARIANT: 'auto-mode-variant',
  BAG_OF_CASH: 'bag-of-cash',
  BANK: 'bank',
  BANK_OUTLINE: 'bank-outline',
  BANK_PLUS: 'bank-plus',
  BATTERY: 'battery',
  BELL_OUTLINE: 'bell-outline',
  CALENDAR: 'calendar',
  CALENDAR_AVAILABLE: 'calendar-available',
  CALENDAR_BUSY: 'calendar-busy',
  CALENDAR_CLOCK: 'calendar-clock',
  CALENDAR_EDIT: 'calendar-edit',
  CALENDAR_EVENT: 'calendar-event',
  CALENDAR_RANGE: 'calendar-range',
  CALENDAR_SYNC: 'calendar-sync',
  CALENDAR_SYNC_OUTLINE: 'calendar-sync-outline',
  CALENDAR_TODAY: 'calendar-today',
  CARD_ACCOUNT_DETAILS_OUTLINE: 'card-account-details-outline',
  CAST: 'cast',
  CELEBRATE: 'celebrate',
  CHART_TIMELINE: 'chart-timeline',
  CHART_TIMELINE_VARIANT_SHIMMER: 'chart-timeline-variant-shimmer',
  CHECK: 'check',
  CHECKBOX_MARKED_CIRCLE_OUTLINE: 'checkbox-marked-circle-outline',
  CHECK_ALL: 'check-all',
  CHEVRON_DOWN: 'chevron-down',
  CHEVRON_LEFT: 'chevron-left',
  CHEVRON_LEFT_START: 'chevron-left-start',
  CHEVRON_RIGHT: 'chevron-right',
  CHEVRON_RIGHT_END: 'chevron-right-end',
  CHEVRON_UP: 'chevron-up',
  CIRCUIT: 'circuit',
  CLIPBOARD_ALERT_OUTLINE: 'clipboard-alert-outline',
  CLIPBOARD_PULSE_OUTLINE: 'clipboard-pulse-outline',
  CLIPBOARD_TEXT_MULTIPLE_OUTLINE: 'clipboard-text-multiple-outline',
  CLIPBOARD_TEXT_OUTLINE: 'clipboard-text-outline',
  CLOCK_ALERT_OUTLINE: 'clock-alert-outline',
  CLOCK_HISTORY: 'clock-history',
  CLOSE: 'close',
  CLOSE_CIRCLE_OUTLINE: 'close-circle-outline',
  CLOSE_THICK: 'close-thick',
  COGS: 'cogs',
  COG_OUTLINE: 'cog-outline',
  COMMENT_QUESTION_OUTLINE: 'comment-question-outline',
  CONSOLE: 'console',
  CONSOLE_LINE: 'console-line',
  CONTACT_SUPPORT_OUTLINE: 'contact-support-outline',
  CONTENT_COPY1: 'content-copy1',
  CONTENT_COPY: 'content-copy',
  CREDIT_CARD: 'credit-card',
  CREDIT_CARD_MULTIPLE_OUTLINE: 'credit-card-multiple-outline',
  CREDIT_CARD_PLUS_OUTLINE: 'credit-card-plus-outline',
  CUBE_UNFOLDED: 'cube-unfolded',
  DELETE_EMPTY_OUTLINE: 'delete-empty-outline',
  DELETE_OUTLINE: 'delete-outline',
  DELETE_VARIANT: 'delete-variant',
  DELTA: 'delta',
  DESCRIPTION_OUTLINE: 'description-outline',
  DEVICE_HUB: 'device-hub',
  DOTS_GRID: 'dots-grid',
  DOTS_HORIZONTAL: 'dots-horizontal',
  DOTS_VERTICAL: 'dots-vertical',
  DOWNLOAD: 'download',
  DOWNLOAD_ALT: 'download-alt',
  EAST: 'east',
  EDIT: 'edit',
  EDIT_OUTLINE: 'edit-outline',
  EMAIL_CHECK_OUTLINE: 'email-check-outline',
  EMAIL_OUTLINE: 'email-outline',
  EMAIL_SEND_OUTLINE: 'email-send-outline',
  EQUALIZER: 'equalizer',
  FACE_AGENT: 'face-agent',
  FILE_DOWNLOAD_OUTLINE: 'file-download-outline',
  FILE_UPLOAD_OUTLINE: 'file-upload-outline',
  FILTERS_HORIZONTAL: 'filters-horizontal',
  FILTER_OUTLINE: 'filter-outline',
  FILTER_VARIANT: 'filter-variant',
  FOLDER_MARKER_OUTLINE: 'folder-marker-outline',
  FORWARD_10: 'forward-10',
  FORWARD_30: 'forward-30',
  FORWARD_5: 'forward-5',
  GAMEPAD: 'gamepad',
  GAMEPAD_TILTED_OUTLINE: 'gamepad-tilted-outline',
  GPS: 'gps',
  GPS_DISABLED: 'gps-disabled',
  GPS_FIXED: 'gps-fixed',
  GROUPS_OUTLINE: 'groups-outline',
  GROUP_ADD: 'group-add',
  GROUP_ADD_OUTLINE: 'group-add-outline',
  HELP: 'help',
  HELP_CIRCLE_OUTLINE: 'help-circle-outline',
  HOME_CITY_OUTLINE: 'home-city-outline',
  HOME_OUTLINE: 'home-outline',
  HOME_REMOVE_OUTLINE: 'home-remove-outline',
  HOME_VARIANT_OUTLINE: 'home-variant-outline',
  IMAGE_ADD_OUTLINE: 'image-add-outline',
  IMAGE_BROKEN_OUTLINE: 'image-broken-outline',
  IMAGE_NOT_SUPPORTED_OUTLINE: 'image-not-supported-outline',
  IMAGE_OUTLINE: 'image-outline',
  INCANDESCENT: 'incandescent',
  INCANDESCENT_DOWN: 'incandescent-down',
  INFORMATION_OUTLINE: 'information-outline',
  INFO_OUTLINED: 'info-outlined',
  KEYBOARD_OUTLINE: 'keyboard-outline',
  KEY_OUTLINE: 'key-outline',
  LAYER_MULTI_OUTLINE: 'layer-multi-outline',
  LAYER_SINGLE_OUTLINE: 'layer-single-outline',
  LIGHTBULB_ON_OUTLINE: 'lightbulb-on-outline',
  LIGHTNING_BOLT: 'lightning-bolt',
  LIST: 'list',
  LIST_BULLETED: 'list-bulleted',
  LIST_NUMBERED: 'list-numbered',
  LOCK_OPEN_OUTLINE: 'lock-open-outline',
  LOCK_OUTLINE: 'lock-outline',
  LOGOUT: 'logout',
  LOGOUT_VARIANT: 'logout-variant',
  MAGNIFY: 'magnify',
  MAP: 'map',
  MAP_MARKER_ALT: 'map-marker-alt',
  MAP_MARKER_EDIT: 'map-marker-edit',
  MAP_MARKER_OUTLINE: 'map-marker-outline',
  MEDIATION: 'mediation',
  MENU: 'menu',
  MENU_DOWN: 'menu-down',
  MENU_LEFT: 'menu-left',
  MENU_RIGHT: 'menu-right',
  MENU_UP: 'menu-up',
  MESSAGE_PROCESSING_OUTLINE: 'message-processing-outline',
  MESSAGE_QUESTION: 'message-question',
  MINUS: 'minus',
  MINUS_CIRCLE_OUTLINE: 'minus-circle-outline',
  NINJA: 'ninja',
  NORTH: 'north',
  NOTIFICATION_BELL: 'notification-bell',
  OPEN_IN_NEW: 'open-in-new',
  OPP_USER_BUSINESS: 'opp-user-business',
  OPP_USER_INDIVIDUAL: 'opp-user-individual',
  PASSWORD: 'password',
  PAYOUTS: 'payouts',
  PENDING_OUTLINE: 'pending-outline',
  PERSON_ADD_OUTLINE: 'person-add-outline',
  PERSON_OUTLINE: 'person-outline',
  PERSON_REMOVE_OUTLINE: 'person-remove-outline',
  PHONE_OUTLINE: 'phone-outline',
  PIN: 'pin',
  PLAYLIST_EDIT: 'playlist-edit',
  PLUS: 'plus',
  PLUS_CIRCLE_OUTLINE: 'plus-circle-outline',
  PROGRESS_ALERT: 'progress-alert',
  PROGRESS_DOWNLOAD: 'progress-download',
  PROGRESS_UPLOAD: 'progress-upload',
  PUBLISH_CHANGES: 'publish-changes',
  REDO: 'redo',
  REFRESH: 'refresh',
  SEARCH: 'search',
  SEND: 'send',
  SETTINGS: 'settings',
  SETTINGS_REFRESH: 'settings-refresh',
  SETTINGS_SUGGEST: 'settings-suggest',
  SETTINGS_UNDO: 'settings-undo',
  SHIELD_ACCOUNT_OUTLINE: 'shield-account-outline',
  SHIELD_KEY_OUTLINE: 'shield-key-outline',
  SHIELD_LOCK_OUTLINE: 'shield-lock-outline',
  SHOPPING_CART: 'shopping-cart',
  SORT_VARIANT_LOCK: 'sort-variant-lock',
  SOUTH: 'south',
  STAR: 'star',
  STAR_OUTLINE: 'star-outline',
  STAR_OUTLINE_FAT: 'star-outline-fat',
  STAR_OUTLINE_THICK: 'star-outline-thick',
  SUPPORT: 'support',
  SUPPORT_AGENT: 'support-agent',
  SWAP_ARROWS: 'swap-arrows',
  SWITCH_ACCOUNT_OUTLINE: 'switch-account-outline',
  SYNC: 'sync',
  SYNC_ALT: 'sync-alt',
  SYNC_DISABLED: 'sync-disabled',
  SYNC_PROBLEM: 'sync-problem',
  TABLET: 'tablet',
  TEXT_BOX_OUTLINE: 'text-box-outline',
  TEXT_BOX_SEARCH_OUTLINE: 'text-box-search-outline',
  TEXT_SEARCH: 'text-search',
  THUMB_DOWN_OUTLINE: 'thumb-down-outline',
  THUMB_UP_OUTLINE: 'thumb-up-outline',
  TIMELINE1: 'timeline1',
  TIMELINE: 'timeline',
  TIMELINE_CHECK_OUTLINE: 'timeline-check-outline',
  TIMELINE_OUTLINE: 'timeline-outline',
  TIMETABLE: 'timetable',
  TOTALLY_ZEN: 'totally-zen',
  TRACK_CHANGES: 'track-changes',
  TRANSACTIONS: 'transactions',
  TRANSLATE: 'translate',
  TRASH_CAN_OUTLINE: 'trash-can-outline',
  TRENDING_DOWN: 'trending-down',
  TRENDING_UP: 'trending-up',
  TUNE: 'tune',
  UNAVAILABLE: 'unavailable',
  UNDO: 'undo',
  UPLOAD: 'upload',
  USER: 'user',
  USERS_OUTLINE: 'users-outline',
  USER_OUTLINE: 'user-outline',
  VERIFIED: 'verified',
  VISBILITY: 'visbility',
  VISIBILITY_OFF: 'visibility-off',
  WALLET_WITHDRAW: 'wallet_withdraw',
  WEST: 'west',
  WIFI_OFF: 'wifi-off',
  WIFI_ON: 'wifi-on',
  WINDOW_CLOSE: 'window-close',
};

export default ICONS;
